import Main from './Pages/Main/Main';


const App = () => {
  return (
    <div>
      <Main />
    </div>
  )
}
export default App;